const Validation = {
  PASSWORD: "^(?=.*[A-Z])(?=.*[0-9])(?=.*[a-z]).{6,}$",
};

export default Validation;
